import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
const PasswordContext = createContext(undefined);
const CORRECT_PASSWORD = 'Heron2021';
const STORAGE_KEY = 'printable_media_auth';
export const PasswordProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        // Check if already authenticated in this session
        const stored = sessionStorage.getItem(STORAGE_KEY);
        return stored === 'true';
    });
    const authenticate = (password) => {
        if (password === CORRECT_PASSWORD) {
            setIsAuthenticated(true);
            sessionStorage.setItem(STORAGE_KEY, 'true');
            return true;
        }
        return false;
    };
    const logout = () => {
        setIsAuthenticated(false);
        sessionStorage.removeItem(STORAGE_KEY);
    };
    return (_jsx(PasswordContext.Provider, { value: { isAuthenticated, authenticate, logout }, children: children }));
};
export const usePassword = () => {
    const context = useContext(PasswordContext);
    if (context === undefined) {
        throw new Error('usePassword must be used within a PasswordProvider');
    }
    return context;
};
